import './styles.css';
import { i18nReady, currentLang } from './core/i18n';
import './ui/landing';

// PWA: register service worker if supported (silent on failure).
if ('serviceWorker' in navigator) {
  // @ts-expect-error virtual module provided by vite-plugin-pwa at build time
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
}

async function boot(): Promise<void> {
  await i18nReady;
  document.documentElement.lang = currentLang() === 'pt-br' ? 'pt-BR' : 'en';
  const app = document.getElementById('app');
  if (!app) throw new Error('#app not found');
  app.innerHTML = '';
  const landing = document.createElement('tpe-landing');
  landing.style.position = 'relative';
  landing.style.display = 'block';
  landing.style.height = '100%';
  landing.style.width = '100%';
  app.appendChild(landing);
}

boot();
